// store/modules/notifications.js

const state = () => ({
    items: [],
    loading: false,
});

const mutations = {
    setNotifications(state, notifications) {
        state.items = notifications;
    },
    setLoading(state, value) {
        state.loading = value;
    },
    clearNotifications(state) {
        state.items = [];
    },
};

const actions = {
    async loadNotifications({ commit }) {
        this._vm.$loading(true); // <- active le loader global
        commit('setLoading', true);
        try {
            const { data } = await this._vm.$http.get('/notifications');
            commit('setNotifications', data);
        } catch (error) {
            console.error("Erreur lors du chargement des notifications :", error);
        } finally {
            commit('setLoading', false);
            this._vm.$loading(false); // <- désactive le loader
        }
    },
    async markNotificationAsRead({ dispatch }, id) {
        try {
            await this._vm.$http.put(`/notifications/${id}/read`);
            dispatch('loadNotifications');
        } catch (err) {
            console.error("Erreur lors du marquage comme lu :", err);
        }
    },
};

const getters = {
    allNotifications: state => state.items,
    notificationCount: state => state.items.length,
    hasNotifications: state => state.items.length > 0,
    isLoadingNotifications: state => state.loading,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
